//-----------------------------------------------
// Fmlx-Numpad
// v1.0 by : Galih Dika Pranata
// v2.0 by : Feliks Wida S
//  Add : auto size displayInput, inc/dec button, max/min range,function validation new value, max decimal precision,floating mode,
//-----------------------------------------------

import React, {Component} from 'react';

import PropTypes from 'prop-types';
import {Modal} from 'react-bootstrap';
import DynamicFont from 'react-dynamic-font';

import {NO_LIMIT} from '@/constants/configurations';

import FmlxNumPadKeys from './lib/FmlxNumpadKeys';

import './FmlxNumpad.less';

const INCREMENT = 'inc';
const DECREMENT = 'dec';

export default class FmlxNumPad extends Component {
  constructor(props) {
    super(props);

    this.state = {
      displayedLabel: '0',
      displayTitle: '',
      displayId: '',
      MAX_PASSWORD_MESSAGE: '',
      MIN_PASSWORD_MESSAGE: '',
      firstInput: false,
      warningMessage: '',
    };
    this.onClickIncDec = this.onClickIncDec.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.initialSetPopUp(nextProps);
  }

  componentDidUpdate(prevProps) {
    const {validationText} = this.props;
    const {warningMessage} = this.state;

    if (validationText && validationText !== prevProps.validationText && warningMessage !== validationText) {
      this.setState({warningMessage: validationText});
    }
  }

  onButtonClicked(key) {
    const {displayedLabel, displayId, firstInput} = this.state;
    const {onValueChanged, minValue, maxValue, maxDigitAfterDecimal, floatingNumpadMode, onOkClicked, validatorNumber} =
      this.props;

    const isPasswordMode = floatingNumpadMode === FmlxNumPad.mode.password;
    let maximumValue = maxValue;

    switch (key) {
      case FmlxNumPadKeys.operationKey.dot: {
        if (!displayedLabel.includes('.')) {
          const newValue = `${displayedLabel}.`;
          this.setState({displayedLabel: newValue, firstInput: false}, onValueChanged(displayId, newValue));
        }
        break;
      }
      case FmlxNumPadKeys.operationKey.negate: {
        if (displayedLabel.includes('-')) {
          const newValue = displayedLabel.slice(1, displayedLabel.length);
          this.setState({displayedLabel: newValue}, onValueChanged(displayId, newValue));
        } else if (displayedLabel !== '0') {
          const newValue = `-${displayedLabel}`;
          this.setState({displayedLabel: newValue}, onValueChanged(displayId, newValue));
        }
        break;
      }
      case FmlxNumPadKeys.operationKey.clear:
        if (isPasswordMode) {
          this.setState({displayedLabel: '', warningMessage: undefined}, onValueChanged(displayId, displayedLabel));
        } else {
          this.setState({displayedLabel: '0', warningMessage: undefined}, onValueChanged(displayId, displayedLabel));
        }
        break;
      case FmlxNumPadKeys.operationKey.delete:
        if (displayedLabel.length === 1) {
          if (isPasswordMode) {
            this.setState({displayedLabel: '', warningMessage: undefined}, onValueChanged(displayId, displayedLabel));
          } else {
            this.setState({displayedLabel: '0', warningMessage: undefined}, onValueChanged(displayId, displayedLabel));
          }
        } else if (displayedLabel || displayedLabel !== '0') {
          let newDisplayedLabel = displayedLabel.slice(0, -1);

          if (newDisplayedLabel && newDisplayedLabel.length === 1 && newDisplayedLabel === '-') newDisplayedLabel = '0';

          if (firstInput)
            // when first button select is delete, make firstinput as false, and continue input, not replace
            this.setState({
              firstInput: !firstInput,
            });

          this.setState(
            {displayedLabel: newDisplayedLabel, warningMessage: undefined},
            onValueChanged(displayId, newDisplayedLabel),
          );
        }
        break;
      case FmlxNumPadKeys.operationKey.ok:
        onOkClicked(displayId, this.validatorInput(displayedLabel));
        break;
      default: {
        // validate new value with parent component
        // return true if new input valid       --> update displayLabel
        // return fals if new input not valid   --> not updateDisplay label
        const isValidNumber = validatorNumber(displayId, displayedLabel, displayedLabel + key);
        if (displayedLabel === '0' && !isPasswordMode) {
          if (isValidNumber) this.setState({displayedLabel: key, firstInput: false}, onValueChanged(displayId, key));
        } else if (displayedLabel === undefined) {
          if (isValidNumber) this.setState({displayedLabel: key, firstInput: false}, onValueChanged(displayId, key));
        } else {
          let newValue = parseFloat(displayedLabel + key);

          // check if 0.000 change to 0.0001 to able comparing with min and max valuee
          if (newValue === 0 && this.countDecimals(displayedLabel + key) > 0) {
            newValue = parseFloat(displayedLabel + key + 1);
          } // in password mode, 0000 change to 10000 to able  comparing with min and max value
          else if (newValue === 0 && isPasswordMode) {
            newValue = parseFloat(1 + displayedLabel + key);
            maximumValue += 1;
          }

          if (firstInput) {
            this.setState({displayedLabel: key, firstInput: !firstInput}, onValueChanged(displayId, key));
          } else if (this.countDecimals(displayedLabel + key) <= maxDigitAfterDecimal) {
            if (floatingNumpadMode === FmlxNumPad.mode.password && newValue > maximumValue) {
              // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
              this.setState({warningMessage: this.state.MAX_PASSWORD_MESSAGE});
            } else if (floatingNumpadMode === FmlxNumPad.mode.password && newValue < minValue) {
              // eslint-disable-next-line react/destructuring-assignment, react/no-access-state-in-setstate
              this.setState({warningMessage: this.state.MIN_PASSWORD_MESSAGE});
            } else if (isValidNumber) {
              this.setState(
                {
                  displayedLabel: displayedLabel + key,
                  warningMessage: undefined,
                },
                onValueChanged(displayId, displayedLabel + key),
              );
            } else {
              this.setState({warningMessage: 'Invalid Input'});
            }
          } else {
            this.setState({
              warningMessage: `Maximum number after the decimal point is ${maxDigitAfterDecimal}  digits.`,
            });
          }
        }
        break;
      }
    }
  }

  onClickIncDec(e) {
    const {displayedLabel} = this.state;
    const {minValue, maxValue, incrementValue, maxDigitAfterDecimal, validationText} = this.props;

    const inputValue = parseFloat(displayedLabel);
    let digitAfterDecimal = this.countDecimals(displayedLabel);
    digitAfterDecimal = digitAfterDecimal === 0 ? maxDigitAfterDecimal : digitAfterDecimal;

    switch (e.currentTarget.id) {
      case INCREMENT:
        if (parseFloat(inputValue) < maxValue) {
          const newInput = (parseFloat(inputValue) + incrementValue).toFixed(digitAfterDecimal);

          this.setState({
            displayedLabel: parseFloat(newInput).toString(),
            warningMessage: undefined,
          });
        } else {
          this.setState({
            warningMessage: validationText,
          });
        }
        break;
      case DECREMENT:
        if (parseFloat(inputValue) > minValue) {
          const newInput = (parseFloat(inputValue) - incrementValue).toFixed(digitAfterDecimal);

          this.setState({
            displayedLabel: parseFloat(newInput).toString(),
            warningMessage: undefined,
          });
        } else {
          this.setState({
            warningMessage: validationText,
          });
        }
        break;
      default:
        break;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  countDecimals(number) {
    let decimal = 0;
    const n = number.toString().split('.');

    if (n[1]) {
      decimal = n[1].length;
    }

    return decimal;
  }

  initialSetPopUp(nextProps) {
    if (nextProps.value) {
      let IsFirstInputActive = false;

      if (nextProps.replaceFirstInput) {
        IsFirstInputActive = true;
      }

      this.setState({
        displayedLabel: nextProps.value.toString(),
        firstInput: IsFirstInputActive,
        warningMessage: nextProps.validationText ? nextProps.validationText : undefined,
      });
    } else if (nextProps.value === 0 && nextProps.floatingNumpadMode === 'password') {
      this.setState({displayedLabel: ''});
    } else if (nextProps.value === 0 && nextProps.floatingNumpadMode !== 'password') {
      this.setState({displayedLabel: '0'});
    } else {
      this.setState({
        displayedLabel: undefined,
        warningMessage: nextProps.validationText ? nextProps.validationText : undefined,
      });
    }

    if (nextProps.title) {
      this.setState({
        displayTitle: nextProps.title,
      });
    }

    if (nextProps.id) {
      this.setState({
        displayId: nextProps.id,
      });
    }

    // add comparation equal 0, sometimes the value is 0
    if (nextProps.maxValue !== NO_LIMIT && (nextProps.maxValue || nextProps.maxValue === 0)) {
      this.setState({
        MAX_PASSWORD_MESSAGE: `Maximum Pin is ${nextProps.maxValue.length} digit`,
      });
    }

    // add comparation equal 0, sometimes the value is 0
    if (nextProps.maxValue !== NO_LIMIT && (nextProps.minValue || nextProps.maxValue === 0)) {
      this.setState({
        MIN_PASSWORD_MESSAGE: `Minimum Pin is ${nextProps.minValue.length} digit`,
      });
    }

    if (nextProps.maxValue === NO_LIMIT) {
      this.setState({
        MAX_PASSWORD_MESSAGE: `Maximum Pin is ${nextProps.maxValue.length} digit`,
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  validatorInput(displayedLabel) {
    // eslint-disable-next-line no-nested-ternary
    return displayedLabel
      ? displayedLabel[displayedLabel.length - 1] === '.'
        ? displayedLabel.slice(0, -1)
        : displayedLabel
      : undefined;
  }

  generateNumPad() {
    const {incDec, buttonSize, isFloatingNumpad, floatingNumpadMode, mainKeys, sideKeys} = this.props;
    const {displayedLabel, warningMessage} = this.state;

    const incDecButton = (
      <div className="incDecWrapper">
        <div className="row incDecRow">
          <button
            type="button"
            id={INCREMENT}
            onClick={this.onClickIncDec}
            className="center incButton"
          >
            <span className="glyphicon glyphicon-triangle-top iconUp" />
          </button>
        </div>
        <div className="row incDecRow">
          <button
            type="button"
            id={DECREMENT}
            onClick={this.onClickIncDec}
            className="center decButton"
          >
            <span className="glyphicon glyphicon-triangle-bottom iconDown" />
          </button>
        </div>
      </div>
    );
    const colDisplayLabel = incDec ? 'col-md-10 numpad-display-text' : 'col-md-12 numpad-display-text';
    const isPasswordMode = floatingNumpadMode === FmlxNumPad.mode.password;

    return (
      <div className="numpad">
        <div className="row center numpad-display">
          <div
            className={colDisplayLabel}
            type={isPasswordMode ? 'password' : null}
          >
            <DynamicFont
              smooth
              content={displayedLabel}
            />
          </div>
          {incDec && <div className="col-md-2">{incDecButton}</div>}
        </div>
        <div className="numpad-validation">{warningMessage}</div>
        <FmlxNumPadKeys
          onKeyClicked={(key) => this.onButtonClicked(key)}
          buttonSize={buttonSize}
          isFloating={isFloatingNumpad}
          mainKeys={mainKeys}
          sideKeys={sideKeys}
        />
      </div>
    );
  }

  generateFloatingNumpad() {
    const {showFloatingNumpad, onClose} = this.props;
    const {displayTitle} = this.state;

    return (
      <Modal
        show={showFloatingNumpad}
        dialogClassName="numpadModal disableTextSelect"
        onHide={onClose}
      >
        <Modal.Header
          className="numpadModalHeader"
          closeButton
        >
          <Modal.Title className="numpadTitle">{displayTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="center">{this.generateNumPad()}</div>
        </Modal.Body>
      </Modal>
    );
  }

  render() {
    const {isFloatingNumpad} = this.props;

    return (
      <>
        {!isFloatingNumpad && this.generateNumPad()}
        {isFloatingNumpad && this.generateFloatingNumpad()}
      </>
    );
  }
}

FmlxNumPad.buttonSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

FmlxNumPad.mode = {
  normal: 'normal',
  password: 'password',
};
FmlxNumPad.mainKeys = {
  calculator: [
    ['7', '8', '9'],
    ['4', '5', '6'],
    ['1', '2', '3'],
    [FmlxNumPadKeys.operationSymbol.dot, '0', FmlxNumPadKeys.operationSymbol.negate],
  ],
  number: [['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0']],
  phone: [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    [FmlxNumPadKeys.operationSymbol.dot, '0', FmlxNumPadKeys.operationSymbol.negate],
  ],
};
FmlxNumPad.sideKeys = {
  floating: [
    FmlxNumPadKeys.operationSymbol.delete,
    FmlxNumPadKeys.operationSymbol.clear,
    FmlxNumPadKeys.operationSymbol.ok,
  ],
  inline: [FmlxNumPadKeys.operationSymbol.delete, FmlxNumPadKeys.operationSymbol.clear],
};

FmlxNumPad.propTypes = {
  validationText: PropTypes.string,
  onValueChanged: PropTypes.func,
  onOkClicked: PropTypes.func,
  validatorNumber: PropTypes.func,
  onClose: PropTypes.func,
  incDec: PropTypes.bool,
  isFloatingNumpad: PropTypes.bool,
  showFloatingNumpad: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  replaceFirstInput: PropTypes.bool,
  mainKeys: PropTypes.array,
  sideKeys: PropTypes.array,
  // eslint-disable-next-line react/no-unused-prop-types
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  incrementValue: PropTypes.number,
  maxDigitAfterDecimal: PropTypes.number,
  minValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  maxValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  buttonSize: PropTypes.oneOf(Object.values(FmlxNumPad.buttonSize)),
  floatingNumpadMode: PropTypes.oneOf(Object.values(FmlxNumPad.mode)),
  // eslint-disable-next-line react/no-unused-prop-types
  id: PropTypes.string,
  // eslint-disable-next-line react/no-unused-prop-types
  title: PropTypes.string,
};

FmlxNumPad.defaultProps = {
  validationText: '',
  validatorNumber: () => true,
  onOkClicked: () => true,
  // eslint-disable-next-line no-unused-vars
  onValueChanged: (numpadId, value) => {
    // return true;
  },
  onClose: () => {},
  incDec: true,
  isFloatingNumpad: false,
  showFloatingNumpad: false,
  replaceFirstInput: false,
  mainKeys: FmlxNumPad.mainKeys.calculator,
  sideKeys: FmlxNumPad.sideKeys.floating,
  id: '',
  value: 0,
  title: '',
  incrementValue: 0.1,
  maxDigitAfterDecimal: 1,
  minValue: 0,
  maxValue: 100,
  buttonSize: FmlxNumPad.buttonSize.medium,
  floatingNumpadMode: FmlxNumPad.mode.normal,
};
